<template>
  <div class="dark-theme-wrapper">
    <div class="container py-5">
      <h1 class="main-title text-center mb-5">ADMINISTRACE</h1>

      <div class="admin-nav mb-5">
        <button
          @click="navigateTo('addMatch')"
          :class="['nav-btn', { active: currentView === 'addMatch' }]"
        >
          <svg
            class="nav-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
            <line x1="16" y1="2" x2="16" y2="6"></line>
            <line x1="8" y1="2" x2="8" y2="6"></line>
            <line x1="3" y1="10" x2="21" y2="10"></line>
            <line x1="12" y1="15" x2="12" y2="21"></line>
            <line x1="9" y1="18" x2="15" y2="18"></line>
          </svg>
          <span>ZÁPASY</span>
        </button>

        <button
          @click="navigateTo('addTeams')"
          :class="['nav-btn', { active: currentView === 'addTeams' }]"
        >
          <svg
            class="nav-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
          </svg>
          <span>TÝMY</span>
        </button>

        <button
          @click="navigateTo('addQuestion')"
          :class="['nav-btn', { active: currentView === 'addQuestion' }]"
        >
          <svg
            class="nav-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="10"></circle>
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
            <line x1="12" y1="17" x2="12.01" y2="17"></line>
          </svg>
          <span>OTÁZKY</span>
        </button>

        <button
          @click="navigateTo('adminResult')"
          :class="['nav-btn', { active: currentView === 'adminResult' }]"
        >
          <svg
            class="nav-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
            ></path>
            <polyline points="14 2 14 8 20 8"></polyline>
            <line x1="16" y1="13" x2="8" y2="13"></line>
            <line x1="16" y1="17" x2="8" y2="17"></line>
            <polyline points="10 9 9 9 8 9"></polyline>
          </svg>
          <span>VÝSLEDKY</span>
        </button>

        <button
          @click="navigateTo('adminSettings')"
          :class="['nav-btn', { active: currentView === 'adminSettings' }]"
        >
          <svg
            class="nav-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="3"></circle>
            <path
              d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"
            ></path>
          </svg>
          <span>NASTAVENÍ</span>
        </button>
      </div>
      <div class="container py-4">
        <div class="mb-4 text-center">
          <button
            @click="copyEmailsToClipboard"
            class="btn btn-outline-warning btn-sm"
          >
            📧 ZKOPÍROVAT EMAILY VŠECH HRÁČŮ
          </button>
        </div>

        <hr />

        <component :is="currentView" />
      </div>

      <div class="content-container">
        <transition name="fade" mode="out-in">
          <div :key="currentView">
            <AddMatch v-if="currentView === 'addMatch'" />
            <AdminSettings v-if="currentView === 'adminSettings'" />
            <AddTeams v-if="currentView === 'addTeams'" />
            <AddQuestion v-if="currentView === 'addQuestion'" />
            <AdminResult v-if="currentView === 'adminResult'" />
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
// 1. Importy komponent
import AddMatch from "./AddMatch.vue";
import AdminSettings from "./AdminSettings.vue";
import AddTeams from "./AddTeams.vue";
import AddQuestion from "./AddQuestion.vue";
import AdminResult from "./AdminResult.vue";

// 2. Importy z Firebase (DŮLEŽITÉ PRO NAČTENÍ EMAILŮ)
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";

export default {
  name: "AdminAccount",
  components: {
    AddMatch,
    AdminSettings,
    AddTeams,
    AddQuestion,
    AdminResult,
  },
  data() {
    return {
      currentView: "addMatch",
    };
  },
  methods: {
    navigateTo(view) {
      this.currentView = view;
    },

    // 3. NOVÁ METODA: Zkopírování emailů do schránky
    async copyEmailsToClipboard() {
      try {
        // Načteme kolekci "users"
        const querySnapshot = await getDocs(collection(db, "users"));

        // Vytáhneme emaily a odstraníme prázdné nebo neplatné
        const emails = querySnapshot.docs
          .map((doc) => doc.data().email)
          .filter((email) => email && email.includes("@"));

        if (emails.length === 0) {
          alert("V databázi nebyli nalezeni žádní uživatelé s emailem.");
          return;
        }

        // Spojíme je čárkou a mezerou (formát vhodný pro Outlook/Gmail)
        const emailString = emails.join(", ");

        // Vložíme do schránky
        await navigator.clipboard.writeText(emailString);

        // Informujeme admina
        alert(
          `✅ HOTOVO!\n\nZkopírováno ${emails.length} emailových adres.\n\n` +
            `Nyní jděte do svého emailu a vložte je do políčka "SKRYTÁ KOPIE" (BCC).\n` +
            `(Nikdy je nedávejte do 'Komu', ať uživatelé nevidí navzájem své adresy!)`
        );
      } catch (error) {
        console.error("Chyba při kopírování:", error);
        alert("Nepodařilo se načíst emaily. Zkontrolujte konzoli.");
      }
    },
  },
};
</script>

<style scoped>
/* =========================================
   DARK THEME STYLING
   ========================================= */

.dark-theme-wrapper {
  background-color: #000000;
  min-height: 100vh;
  color: #ffffff;
  font-family: "Roboto", sans-serif;
}

.main-title {
  font-size: 2.5rem;
  font-weight: 800;
  letter-spacing: 2px;
  color: #fff;
  text-transform: uppercase;
}

/* Navigační panel (Wrapper) */
.admin-nav {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
  background: #111;
  padding: 10px;
  border-radius: 12px;
  border: 1px solid #333;
}

/* Tlačítka navigace */
.nav-btn {
  background-color: transparent;
  color: #888;
  padding: 12px 20px;
  border: none;
  cursor: pointer;
  border-radius: 8px;
  font-weight: bold;
  font-size: 0.85rem;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 10px;
  letter-spacing: 1px;
}

.nav-icon {
  width: 20px;
  height: 20px;
  stroke: #888;
  transition: stroke 0.3s ease;
}

/* Hover stav */
.nav-btn:hover {
  background-color: #1a1a1a;
  color: #fff;
}

.nav-btn:hover .nav-icon {
  stroke: #fff;
}

/* Aktivní stav */
.nav-btn.active {
  background-color: rgba(220, 53, 69, 0.1); /* Jemně červené pozadí */
  color: #dc3545; /* Červený text */
}

.nav-btn.active .nav-icon {
  stroke: #dc3545; /* Červená ikona */
}

/* Obsahová část */
.content-container {
  min-height: 400px;
}

/* Animace přepínání */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
